const REDACTED_KEYS = new Set([
  'phone',
  'email',
  'addresses',
  'creditCards',
  'preferences',
  'address_city',
  'address_id',
  'address_line_1',
  'address_line_2',
  'address_state',
  'zip',
])

const REDACTED_PATTERNS = [/^password$/i]

export function redactSensitiveData(obj: object): Record<string, unknown> {
  const redacted: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(obj)) {
    const shouldRedact =
      REDACTED_KEYS.has(key) || REDACTED_PATTERNS.some((pattern) => pattern.test(key))

    if (shouldRedact) {
      redacted[key] = '[REDACTED]'
    } else if (value && typeof value === 'object' && !Array.isArray(value)) {
      redacted[key] = redactSensitiveData(value)
    } else if (Array.isArray(value)) {
      redacted[key] = value.map((item) =>
        item && typeof item === 'object' ? redactSensitiveData(item) : item,
      )
    } else {
      redacted[key] = value
    }
  }

  return redacted
}
